export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpenEprofileTerhesseg');
    },
    closeForm({commit}) {
        commit('setFormCloseEprofileTerhesseg');
    }
}
